import {
  useEffect,
  useRef,
  useState
} from 'react'
import { useSelector } from 'react-redux'
import {
  Box,
  Flex,
  Input,
  Stack,
  Text
} from '@chakra-ui/react'
import { usersSelectors } from 'store'
import { CloseIcon } from 'assets/icons'
import { COLORS } from 'utils/styles'
import { v4 as uuid } from 'uuid'

export const Affinities = ({
  affinitiesArray,
  setAffinitiesArray,
  incomplete
}) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false)
  const [affinitiesInput, setAffinitiesInput] = useState('')

  const { searchBar } = useSelector(usersSelectors)

  const affinitiesListRef = useRef(null)
  const inputRef = useRef(null)

  const handleDeleteCodeWord = (id) => {
    const newArray = affinitiesArray.filter((item) => item.id !== id)
    setAffinitiesArray(newArray)
  }

  const handleAddAffinities = (e) => {
    if (!affinitiesArray.map((item) => item.title).includes(e.title)) {
      setAffinitiesArray([...affinitiesArray, { id: e.id, title: e.title }])
      setIsPopupOpen(false)
      setAffinitiesInput('')
    }
  }

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        affinitiesListRef.current
        && !affinitiesListRef.current.contains(e.target)
        && !inputRef.current.contains(e.target)
      ) {
        setIsPopupOpen(false)
      }
    }
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#once
    // If {once: true}, the listener would be automatically removed when invoked.
    document.body.addEventListener('mousedown', handleOutsideClick, { once: true })
  }, [isPopupOpen])

  const filterAffinityList = (
    affinities = searchBar?.affinities
  ) => affinities?.slice(0, 15).map((item) => {
    const highlightPart = () => {
      const lowerTitle = item?.title.toLowerCase()
      const lowerSearch = affinitiesInput.toLowerCase()

      const matchIndex = lowerTitle.indexOf(lowerSearch)
      const matchedText = item?.title.slice(matchIndex, matchIndex + affinitiesInput.length)

      return (
        <Text cursor="pointer">
          {item?.title.slice(0, matchIndex)}
          <Text as="span" fontWeight="bold">{matchedText}</Text>
          {item?.title.slice(matchIndex + affinitiesInput.length)}
        </Text>
      )
    }

    return (
      <Box
        key={uuid()}
        onClick={() => handleAddAffinities(item)}
        mr="5px !important"
        p="6px 18px"
        cursor="pointer"
        borderRadius="full"
        bg={COLORS.lightGray}
        width="max-content"
        alignItems="center"
        name={item.title}
      >
        {
          affinitiesInput
            ? highlightPart()
            : item.title
        }
      </Box>
    )
  })

  const [filteredAffinityList, setFilteredAffinityList] = useState(filterAffinityList())

  useEffect(() => {
    let affinityListTemp = searchBar?.affinities
    const tempAffinitiesInput = affinitiesInput.toLowerCase()

    if (affinitiesInput !== '') {
      affinityListTemp = affinityListTemp.map((item) => {
        const title = item.title.toLowerCase()
        let score = 0

        if (title.startsWith(tempAffinitiesInput)) {
          score = 3
        } else if (title.endsWith(tempAffinitiesInput)) {
          score = 2
        } else if (title.includes(tempAffinitiesInput)) {
          score = 1
        }

        return {
          id: item?.id,
          title: item?.title,
          score
        }
      })
        .filter((item) => item.score > 0)
        .sort((a, b) => b.score - a.score)
    }

    setFilteredAffinityList(filterAffinityList(affinityListTemp))
  }, [affinitiesInput, affinitiesArray])

  return (
    <Stack direction="column" spacing="1rem">
      <Flex gap={2}>
        {affinitiesArray.length <= 0 && incomplete === true
          ? (
            <Text fontSize="20px" fontWeight={700} color="red">
              Affinities
            </Text>
          )
          : (
            <Text fontSize="20px" fontWeight={700}>
              Affinities
            </Text>
          )}
      </Flex>

      <Stack
        rowGap="1rem"
        columnGap="10px"
        spacing="unset"
        wrap="wrap"
        direction="row"
        display={affinitiesArray.length > 0 ? 'flex' : 'none'}
      >
        {affinitiesArray.map((item) => (
          <Stack
            key={uuid()}
            direction="row"
            p="6px 18px"
            borderRadius="full"
            bg={COLORS.gold}
            width="max-content"
            alignItems="center"
          >
            <Text data-name="affinity-title">{item.title}</Text>
            <Box onClick={() => handleDeleteCodeWord(item.id)} name="delete-affinity" cursor="pointer">
              <CloseIcon />
            </Box>
          </Stack>
        ))}
      </Stack>

      <Box>
        <Input
          ref={inputRef}
          placeholder="Select Affinities"
          value={affinitiesInput}
          onChange={(e) => setAffinitiesInput(e.target.value)}
          onFocus={() => setIsPopupOpen(true)}
          name="profile_affinities"
        />
      </Box>

      {isPopupOpen && (
        <Stack
          ref={affinitiesListRef}
          gap="10px"
          spacing="0px"
          direction="row"
          flexWrap="wrap"
          data-name="affinityList"
          maxHeight="14em"
          overflowY="scroll"
        >
          { filteredAffinityList }
        </Stack>
      )}
    </Stack>
  )
}
